<app-privacy-banner *ngIf="isAuthenticated"></app-privacy-banner>
<div class="d-flex agency-container min-vh-100">
  <app-agency-sidebar></app-agency-sidebar>
  <div class="wrapper pb-px-24">
    <app-agency-header></app-agency-header>
    <router-outlet></router-outlet>
  </div>
</div>
<app-footer *ngIf="isAuthenticated"></app-footer>
<ng-container *ngIf="isChatActive">
  <button class="floating-chat-button" (click)="toggleChat()" [title]="totalUnreadCount > 0 ? totalUnreadCount + ' message(s) non lu(s)' : 'Ouvrir la messagerie'">
    <svg-icon src="assets/icons/send-white.svg"></svg-icon>
    <span class="chat-badge" *ngIf="totalUnreadCount > 0">{{ totalUnreadCount }}</span>
  </button>
  <app-chat-popup *ngIf="isChatOpen" (closeChat)="toggleChat()"></app-chat-popup>
</ng-container>
